export enum EventKind {
  'EARN' = 'EARN',
  'BURN' = 'BURN',
  'MAPPED_EARN' = 'MAPPED_EARN',
}

export enum EventSource {
  QUALIFIO_LOYALTY = 'QUALIFIO_LOYALTY',
  QUALIFIO_ENGAGE = 'QUALIFIO_ENGAGE',
  ECOMMERCE = 'ECOMMERCE',
  BINARY = 'BINARY',
  REFERRAL = 'REFERRAL',
  ADVANCED_FORMAT = 'ADVANCED_FORMAT',
}

//TODO: verify facebook events, does names have sense ?

export enum EventName {
  PROFILE_CREATION = 'PROFILE_CREATION',
  BIRTHDAY = 'BIRTHDAY',
  MEMBER_VISIT = 'MEMBER_VISIT',
  MEMBER_CLICK = 'MEMBER_CLICK',
  LEVEL_CHANGE = 'LEVEL_CHANGE',
  CAMPAIGN = 'CAMPAIGN',
  PURCHASE = 'PURCHASE',
  BASIC = 'BASIC',
  BURNING = 'BURNING',
  ACCESS = 'ACCESS',
  ECOMMERCE = 'ECOMMERCE',
  PREDICTION = 'PREDICTION',
}

export const EVENT_NAMES_BY_SOURCES: { [source: string]: EventName[] } = {
  [EventSource.QUALIFIO_LOYALTY]: [
    EventName.PROFILE_CREATION,
    EventName.BIRTHDAY,
    EventName.MEMBER_VISIT,
    EventName.MEMBER_CLICK,
    EventName.LEVEL_CHANGE,
  ],
  [EventSource.QUALIFIO_ENGAGE]: [EventName.CAMPAIGN],
  [EventSource.ADVANCED_FORMAT]: [EventName.PREDICTION],
  [EventSource.ECOMMERCE]: [EventName.PURCHASE],
  [EventSource.BINARY]: [EventName.BASIC],
  [EventSource.REFERRAL]: [EventName.PROFILE_CREATION, EventName.ECOMMERCE],
};
